<template>
  <div class="reg-config-page">
    <div class="reg-config-layout">
          <!-- 左侧国家列表 -->
          <div class="reg-sidebar">
            <div class="sidebar-add-area">
              <el-button
                v-auth="'business:regConfig:save'"
                v-if="!showCountrySelect"
                type="primary"
                size="small"
                icon="el-icon-plus"
                style="width:100%;"
                @click="openCountrySelect">添加国家配置</el-button>
              <div v-else class="select-with-close">
                <el-select
                  ref="countrySelect"
                  v-model="addingCountry"
                  filterable
                  placeholder="搜索国家..."
                  size="small"
                  style="flex:1;"
                  @change="onCountrySelect"
                  popper-class="country-select-popper"
                >
                  <el-option
                    v-for="c in allCountries"
                    :key="c.countryCode"
                    :label="c.countryCode + ' - ' + (c.countryCname || c.countryName)"
                    :value="c.countryCode"
                  >
                    <span style="float:left;">{{ c.countryCode }}</span>
                    <span style="float:right;color:#8492a6;font-size:13px;">{{ c.countryCname || c.countryName }}</span>
                  </el-option>
                </el-select>
                <i class="el-icon-close close-select-btn" @click="onCountryClear"></i>
              </div>
            </div>
            <div class="country-list">
              <div
                class="country-item"
                :class="{ active: currentCountry === 'default' }"
                @click="switchCountry('default')"
              >
                <span class="country-icon">⚙️</span>
                <span class="country-name">默认配置</span>
              </div>
              <div
                v-for="c in sidebarCountries"
                :key="c.countryCode"
                class="country-item"
                :class="{ active: currentCountry === c.countryCode }"
                @click="switchCountry(c.countryCode)"
              >
<!--                {{ getFlagEmoji(c.countryCode) }}-->
                <span class="country-icon">📍</span>
                <span class="country-name">{{ c.countryCode }} - {{ c.countryCname || c.countryName }}</span>
                <i
                  v-auth="'business:regConfig:delete'"
                  class="el-icon-delete country-delete"
                  title="删除该国家的全部注册配置"
                  @click.stop="handleCountryMenu('remove', c)"
                ></i>
              </div>
            </div>
          </div>

          <!-- 右侧配置内容区 -->
          <div class="reg-content" v-loading="regConfigLoading">
            <!-- 配置能力说明 -->
            <div class="capability-banner">
              <div class="capability-title">⚙️ 开户配置通用能力</div>
              <p class="capability-subtitle">以下四项能力作为开户配置的通用底层能力，覆盖所有字段与问题。具体哪些地区收集哪些资料，由合规部门确认后配置，不统一写死。</p>
              <div class="capability-grid">
                <div class="capability-item"><span class="capability-icon">👁️</span><span class="capability-name">显示规则</span><span class="capability-desc">按国家/地区/客户类型决定字段是否显示</span></div>
                <div class="capability-item"><span class="capability-icon">✏️</span><span class="capability-name">必填规则</span><span class="capability-desc">支持必填、选填、条件式必填三态</span></div>
                <div class="capability-item"><span class="capability-icon">⏰</span><span class="capability-name">收集时间</span><span class="capability-desc">注册时 / 注册后</span></div>
                <div class="capability-item"><span class="capability-icon">📄</span><span class="capability-name">文件规则</span><span class="capability-desc">文件类型、有效期、正反面、补充证明</span></div>
              </div>
            </div>

            <div class="section-title">审核模式</div>
            <div class="review-mode-cards">
              <div
                class="review-mode-card"
                :class="{ active: currentReviewMode === 1 }"
                @click="switchReviewMode(1)"
              >
                <span class="card-icon">🤖</span>
                <div class="card-info">
                  <div class="card-name">自动审核</div>
                  <div class="card-desc">系统自动通过审核，高风险将触发人工审核。</div>
                </div>
                <el-tag v-if="currentReviewMode === 1" type="success" size="mini">当前</el-tag>
              </div>
              <div
                class="review-mode-card"
                :class="{ active: currentReviewMode === 2 }"
                @click="switchReviewMode(2)"
              >
                <span class="card-icon">👤</span>
                <div class="card-info">
                  <div class="card-name">人工审核</div>
                  <div class="card-desc">人工逐一审核，加强异常情况风控。</div>
                </div>
                <el-tag v-if="currentReviewMode === 2" type="warning" size="mini">当前</el-tag>
              </div>
            </div>

            <div class="section-title" style="margin-top:24px;">注册方式配置</div>
            <el-tabs v-model="regMethodTab">
              <el-tab-pane label="手机注册" name="phone">
                <div class="cfg-card">
                  <div class="cfg-card-header">
                    <span>📱 手机注册</span>
                    <el-switch
                      v-model="phoneConfig.enabled"
                      :active-value="1"
                      :inactive-value="2"
                      active-color="var(--brand-primary)"
                      style="margin-left:auto;">
                    </el-switch>
                  </div>
                  <div class="cfg-card-body" v-show="phoneConfig.enabled === 1">
                    <div class="cfg-section">
                      <div class="cfg-section-title">注册时收集信息</div>
                      <div class="cfg-row">
                        <span class="cfg-label">注册必填</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="phoneRequired.phone" disabled>手机号</el-checkbox>
                          <el-checkbox v-model="phoneRequired.password">密码</el-checkbox>
                          <el-checkbox v-model="phoneRequired.confirmPassword">确认密码</el-checkbox>
                          <el-checkbox v-model="phoneRequired.country">国家/地区</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row">
                        <span class="cfg-label">KYC信息收集</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="phoneKyc.realName">真实姓名</el-checkbox>
                          <el-checkbox v-model="phoneKyc.idDoc" @change="onPhoneIdDocChange">证件类型 + 证件号码</el-checkbox>
                          <el-checkbox v-model="phoneKyc.birthDate">出生日期</el-checkbox>
                          <el-checkbox v-model="phoneKyc.birthCountry">出生国家</el-checkbox>
                          <el-checkbox v-model="phoneKyc.nationality">国籍</el-checkbox>
                          <el-checkbox v-model="phoneKyc.residenceCountry">居住国家</el-checkbox>
                          <el-checkbox v-model="phoneKyc.taxResidence">税务居民地</el-checkbox>
                          <el-checkbox v-model="phoneKyc.tinNumber">税务识别号(TIN)</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row" v-show="phoneKyc.idDoc">
                        <span class="cfg-label">证件类型池</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="phoneDocTypes.idCard">身份证</el-checkbox>
                          <el-checkbox v-model="phoneDocTypes.passport">护照</el-checkbox>
                          <el-checkbox v-model="phoneDocTypes.driverLicense">驾驶证</el-checkbox>
                          <el-checkbox v-model="phoneDocTypes.residencePermit">居留许可</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row">
                        <span class="cfg-label">证件照片</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="phoneDocPhotos.front">证件正面</el-checkbox>
                          <el-checkbox v-model="phoneDocPhotos.back">证件反面</el-checkbox>
                          <el-checkbox v-model="phoneDocPhotos.handheld">手持证件</el-checkbox>
                        </div>
                      </div>
                        <!--
                      <div class="cfg-row">
                        <span class="cfg-label">生物识别服务</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="phoneBiometric.selfie">自拍照/活体检测</el-checkbox>
                          <el-checkbox v-model="phoneBiometric.faceCompare">人脸与证件比对</el-checkbox>
                        </div>
                      </div>
                       -->
                    </div>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="邮箱注册" name="email">
                <div class="cfg-card">
                  <div class="cfg-card-header">
                    <span>✉️ 邮箱注册</span>
                    <el-switch
                      v-model="emailConfig.enabled"
                      :active-value="1"
                      :inactive-value="2"
                      active-color="var(--brand-primary)"
                      style="margin-left:auto;">
                    </el-switch>
                  </div>
                  <div class="cfg-card-body" v-show="emailConfig.enabled === 1">
                    <div class="cfg-section">
                      <div class="cfg-section-title">注册时收集信息</div>
                      <div class="cfg-row">
                        <span class="cfg-label">注册必填</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="emailRequired.email" disabled>邮箱</el-checkbox>
                          <el-checkbox v-model="emailRequired.password">密码</el-checkbox>
                          <el-checkbox v-model="emailRequired.confirmPassword">确认密码</el-checkbox>
                          <el-checkbox v-model="emailRequired.country">国家/地区</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row">
                        <span class="cfg-label">KYC信息收集</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="emailKyc.realName">真实姓名</el-checkbox>
                          <el-checkbox v-model="emailKyc.idDoc" @change="onEmailIdDocChange">证件类型 + 证件号码</el-checkbox>
                          <el-checkbox v-model="emailKyc.birthDate">出生日期</el-checkbox>
                          <el-checkbox v-model="emailKyc.birthCountry">出生国家</el-checkbox>
                          <el-checkbox v-model="emailKyc.nationality">国籍</el-checkbox>
                          <el-checkbox v-model="emailKyc.residenceCountry">居住国家</el-checkbox>
                          <el-checkbox v-model="emailKyc.taxResidence">税务居民地</el-checkbox>
                          <el-checkbox v-model="emailKyc.tinNumber">税务识别号(TIN)</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row" v-show="emailKyc.idDoc">
                        <span class="cfg-label">证件类型池</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="emailDocTypes.idCard">身份证</el-checkbox>
                          <el-checkbox v-model="emailDocTypes.passport">护照</el-checkbox>
                          <el-checkbox v-model="emailDocTypes.driverLicense">驾驶证</el-checkbox>
                          <el-checkbox v-model="emailDocTypes.residencePermit">居留许可</el-checkbox>
                        </div>
                      </div>
                      <div class="cfg-row">
                        <span class="cfg-label">证件照片</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="emailDocPhotos.front">证件正面</el-checkbox>
                          <el-checkbox v-model="emailDocPhotos.back">证件反面</el-checkbox>
                          <el-checkbox v-model="emailDocPhotos.handheld">手持证件</el-checkbox>
                        </div>
                      </div>
                       <!--
                      <div class="cfg-row">
                        <span class="cfg-label">生物识别服务</span>
                        <div class="cfg-check-group">
                          <el-checkbox v-model="emailBiometric.selfie">自拍照/活体检测</el-checkbox>
                          <el-checkbox v-model="emailBiometric.faceCompare">人脸与证件比对</el-checkbox>
                        </div>
                      </div>
                      -->
                    </div>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="交易组别配置" name="group">
                <div class="cfg-card">
                  <div class="cfg-card-header">
                    <span>🏷️ 交易组别配置</span>
                    <span style="font-size:12px;color:#909399;">开启后，客户端注册时需选择交易组别</span>
                    <el-switch v-model="requireSelectGroup" :active-value="1" :inactive-value="2"
                      active-color="var(--brand-primary)" style="margin-left:auto;">
                    </el-switch>
                  </div>
                  <div class="cfg-card-body" :class="{ 'group-body-disabled': requireSelectGroup !== 1 }">
                    <div v-if="tradeGroups.length === 0" class="group-empty">
                      当前国家暂无真实交易组，请先在「交易组别」菜单中为该国家配置真实交易组
                    </div>
                    <el-table v-else :data="tradeGroups" size="mini" border style="width:100%;">
                      <el-table-column type="index" label="#" width="44" align="center"></el-table-column>
                      <el-table-column prop="groupCode" label="组别ID" width="100" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="currency" label="默认币种" width="72" align="center">
                        <template slot-scope="{ row }">
                          <el-tag size="mini">{{ row.currency }}</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="组别杠杆" width="76" align="center">
                        <template slot-scope="{ row }">
                          <span v-if="row.groupLeverage">{{ '1:' + row.groupLeverage }}</span>
                          <span v-else style="color:#909399;">-</span>
                        </template>
                      </el-table-column>
                      <!-- 首次入金门槛：单位取本行「默认币种」（金额取后台配置值）；0 与空值都表示不设门槛，统一显示 -
                           只读展示列，与「交易组别」页的同名列口径一致，改门槛请去交易组别菜单 -->
                      <el-table-column label="入金门槛" width="96" align="right">
                        <template slot-scope="{ row }">
                          <span v-if="Number(row.minThreshold) > 0">{{ formatAmount(row.minThreshold) }}</span>
                          <span v-else style="color:#909399;">-</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="groupName" label="交易组别" min-width="88" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="mt5GroupPath" label="MT5交易组" min-width="126" show-overflow-tooltip></el-table-column>
                      <el-table-column label="客户端展示名称" min-width="108">
                        <template slot-scope="{ row }">
                          <el-input v-model="row.displayName" size="mini" maxlength="100" placeholder="展示给客户的名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="说明文案" min-width="124">
                        <template slot-scope="{ row }">
                          <el-input v-model="row.displayContent" size="mini" maxlength="255" placeholder="说明文案"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="是否展示" width="62" align="center">
                        <template slot-scope="{ row }">
                          <el-checkbox v-model="row.shown" @change="onGroupShowChange(row)"></el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column label="客户端默认" width="74" align="center">
                        <template slot-scope="{ row }">
                          <el-radio v-model="groupDefaultId" :label="row.id" :disabled="!row.shown">默认</el-radio>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" width="58" align="center">
                        <template slot-scope="{ row }">
                          <el-button v-auth="'business:regConfig:edit'" type="text" size="mini" @click="openGroupEdit(row)">编辑</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>



            <!-- 注册补充资料配置 -->
            <div class="cfg-card" style="margin-top:24px;" v-if="regMethodTab !== 'group'">
              <div class="cfg-card-header">
                <span>📎</span><span style="margin-left:8px;">注册补充资料配置</span>
                <el-switch v-model="currSuppMaster" :active-value="1" :inactive-value="2"
                  active-color="var(--brand-primary)" style="margin-left:auto;">
                </el-switch>
              </div>
              <div class="cfg-card-body" style="padding:0;" v-show="currSuppMaster===1">
                <div v-for="s in currSupps" :key="s.type" class="supplement-sub-item">
                  <div class="supplement-sub-header" @click="s.expanded=!s.expanded">
                    <span :style="{transform:s.expanded?'rotate(90deg)':'',display:'inline-block',transition:'transform 0.2s',marginRight:'8px'}">▶</span>
                    <span>{{ s.icon }}</span>
                    <span style="margin:0 8px;font-weight:500;">{{ s.label }}</span>
                    <el-switch v-model="s.enabled" :active-value="1" :inactive-value="2"
                      active-color="var(--brand-primary)" style="margin-left:auto;" @click.native.stop>
                    </el-switch>
                  </div>
                  <div class="supplement-sub-body" v-show="s.expanded && s.enabled===1">
                    <div class="cfg-row">
                      <span class="cfg-label">是否收集</span>
                      <div class="cfg-control">
                        <el-radio-group v-model="s.collectMode" size="small">
                          <el-radio-button label="open">注册时收集</el-radio-button>
                          <el-radio-button label="later">注册后补充</el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                    <!-- 地址证明 -->
                    <template v-if="s.type==='address'">
                      <div class="cfg-row"><span class="cfg-label">收集字段</span><div class="cfg-check-group"><el-checkbox v-model="s.fields.text">居住地址（文本）</el-checkbox><el-checkbox v-model="s.fields.file" @change="onAddrProofFile(s)">地址证明文件</el-checkbox></div></div>
                      <div class="cfg-row" v-show="s.fields.file"><span class="cfg-label">地址证明类型</span><div class="cfg-check-group"><el-checkbox v-model="s.addrTypes.utility">水电账单</el-checkbox><el-checkbox v-model="s.addrTypes.bank">银行对账单</el-checkbox><el-checkbox v-model="s.addrTypes.government">政府信函</el-checkbox></div></div>
                      <div class="cfg-row"><span class="cfg-label">文件有效期</span><el-input-number v-model="s.validMonths" :min="1" size="small" style="width:160px;"></el-input-number><span style="margin-left:8px;font-size:12px;color:#909399;">个月内</span></div>
                    </template>
                    <!-- 银行资料 -->
                    <template v-if="s.type==='bank'">
                      <div class="cfg-row"><span class="cfg-label">账户持有人核对</span><div class="cfg-control"><el-switch v-model="s.bankFields.verifyHolder" active-color="var(--brand-primary)" size="small"></el-switch><span style="margin-left:8px;font-size:12px;color:#909399;">是否本人持有</span></div></div>
                      <div class="cfg-row"><span class="cfg-label">银行字段</span><div class="cfg-check-group"><el-checkbox v-model="s.bankFields.bankName">开户银行</el-checkbox><el-checkbox v-model="s.bankFields.accountNo">银行账号</el-checkbox><el-checkbox v-model="s.bankFields.swift">SWIFT Code</el-checkbox><el-checkbox v-model="s.bankFields.iban">IBAN</el-checkbox><el-checkbox v-model="s.bankFields.sortCode">Sort Code</el-checkbox></div></div>
                    </template>
                    <!-- 资金来源证明 -->
                    <template v-if="s.type==='fund'">
                      <div class="cfg-row"><span class="cfg-label">资金来源</span><div class="cfg-check-group"><span style="font-size:12px;color:#909399;width:100%;margin-bottom:2px;">多选问题：用户财富积累及本次入金/交易资金的具体来源</span><el-checkbox v-model="s.fundSources.salary">工资收入</el-checkbox><el-checkbox v-model="s.fundSources.investment">投资收益</el-checkbox><el-checkbox v-model="s.fundSources.deposit">银行存款</el-checkbox><el-checkbox v-model="s.fundSources.business">经营所得</el-checkbox><el-checkbox v-model="s.fundSources.inheritance">遗产继承</el-checkbox><el-checkbox v-model="s.fundSources.property">房产出售</el-checkbox><el-checkbox v-model="s.fundSources.loan">贷款</el-checkbox><el-checkbox v-model="s.fundSources.gift">赠与</el-checkbox><el-checkbox v-model="s.fundSources.other">其他</el-checkbox></div></div>
                      <div class="cfg-row"><span class="cfg-label">需提交资料</span><div class="cfg-check-group"><el-checkbox v-model="s.fundDocs.bankStatement">银行流水</el-checkbox><el-checkbox v-model="s.fundDocs.taxReceipt">完税证明</el-checkbox><el-checkbox v-model="s.fundDocs.assetProof">资产证明</el-checkbox><el-checkbox v-model="s.fundDocs.bizLicense">营业执照(企业主)</el-checkbox></div></div>
                    </template>
                    <!-- 合规及监管筛查 -->
                    <template v-if="s.type==='compliance'">
                      <div class="cfg-divider" style="margin:8px 0;border-top:1px dashed #e4e7ed;"></div>
                      <div class="cfg-section-title" style="font-size:12px;">📝 基础声明题 <span style="font-size:11px;color:#909399;font-weight:400;">所有地区默认启用</span></div>
                      <div class="cfg-row"><span class="cfg-label">金融犯罪</span><div class="cfg-control"><span style="font-size:12px;color:#606266;margin-right:12px;">是否曾被指控或判定金融犯罪？</span><el-radio-group v-model="s.compliance.financialCrime" size="small"><el-radio :label="0">否</el-radio><el-radio :label="1">是</el-radio></el-radio-group></div></div>
                      <div v-show="s.compliance.financialCrime===1" style="padding:4px 12px;margin:0 0 8px 120px;background:#fef0f0;border-radius:4px;font-size:12px;color:#f56c6c;">回答"是"需收集补充信息并触发人工合规审核<br>涉及主体、国家、日期、事件性质、处理结果 → 接入 review_task 审核流</div>
                      <div class="cfg-row"><span class="cfg-label">监管处罚</span><div class="cfg-control"><span style="font-size:12px;color:#606266;margin-right:12px;">是否曾被监管机构处罚？</span><el-radio-group v-model="s.compliance.regulatoryAction" size="small"><el-radio :label="0">否</el-radio><el-radio :label="1">是</el-radio></el-radio-group></div></div>
                      <div v-show="s.compliance.regulatoryAction===1" style="padding:4px 12px;margin:0 0 8px 120px;background:#fef0f0;border-radius:4px;font-size:12px;color:#f56c6c;">回答"是"需收集补充信息并触发人工合规审核<br>涉及主体、国家、日期、事件性质、处理结果 → 接入 review_task 审核流</div>
                      <div class="cfg-row"><span class="cfg-label">制裁名单</span><div class="cfg-control"><span style="font-size:12px;color:#606266;margin-right:12px;">是否在制裁名单中？</span><el-radio-group v-model="s.compliance.sanctionsList" size="small"><el-radio :label="0">否</el-radio><el-radio :label="1">是</el-radio></el-radio-group></div></div>
                      <div v-show="s.compliance.sanctionsList===1" style="padding:4px 12px;margin:0 0 8px 120px;background:#fef0f0;border-radius:4px;font-size:12px;color:#f56c6c;">回答"是"需收集补充信息并触发人工合规审核<br>涉及主体、国家、日期、事件性质、处理结果 → 接入 review_task 审核流</div>
                      <div class="cfg-row"><span class="cfg-label">PEP筛查</span><div class="cfg-control"><span style="font-size:12px;color:#606266;margin-right:12px;">是否为政治公众人物（PEP）？</span><el-radio-group v-model="s.compliance.pep" size="small"><el-radio :label="0">否</el-radio><el-radio :label="1">是</el-radio></el-radio-group></div></div>
                      <div v-show="s.compliance.pep===1" style="padding:4px 12px;margin:0 0 8px 120px;background:#fef0f0;border-radius:4px;font-size:12px;color:#f56c6c;">回答"是"需收集补充信息并触发人工合规审核<br>涉及主体、国家、日期、事件性质、处理结果 → 接入 review_task 审核流</div>
                      <div class="cfg-row"><span class="cfg-label">美国人声明</span><div class="cfg-control"><span style="font-size:12px;color:#606266;margin-right:12px;">是否为美国税务居民或受FATCA管辖？</span><el-radio-group v-model="s.compliance.fatca" size="small"><el-radio :label="0">否</el-radio><el-radio :label="1">是</el-radio></el-radio-group></div></div>
                      <div v-show="s.compliance.fatca===1" style="padding:4px 12px;margin:0 0 8px 120px;background:#fef0f0;border-radius:4px;font-size:12px;color:#f56c6c;">命中规则设置 —— 复用 kyc_anomaly_rule 组合条件配置<div class="cfg-check-group" style="margin-top:4px;"><el-checkbox v-model="s.compliance.fatcaRules.birthCountry">出生国为美国</el-checkbox><el-checkbox v-model="s.compliance.fatcaRules.nationalityUS">国籍包含美国</el-checkbox><el-checkbox v-model="s.compliance.fatcaRules.residenceUS">居住国为美国</el-checkbox><el-checkbox v-model="s.compliance.fatcaRules.taxUS">税务居民地为美国</el-checkbox><el-checkbox v-model="s.compliance.fatcaRules.phoneUS">美国联系电话</el-checkbox><el-checkbox v-model="s.compliance.fatcaRules.addressUS">美国通讯地址</el-checkbox></div></div>
                      <div class="cfg-divider" style="margin:8px 0;border-top:1px dashed #e4e7ed;"></div>
                      <div class="cfg-section-title" style="font-size:12px;">🔒 严格KYC地区追加项 <span style="font-size:11px;color:#909399;font-weight:400;">仅特定地区显示</span></div>
                      <div class="cfg-row"><span class="cfg-label">启用项</span><div class="cfg-check-group"><el-checkbox v-model="s.compliance.strictKyc.selfRep">是否代表本人开户</el-checkbox><el-checkbox v-model="s.compliance.strictKyc.thirdPartyFund">是否使用第三方资金</el-checkbox><el-checkbox v-model="s.compliance.strictKyc.pepRelation">PEP关联人筛查</el-checkbox></div></div>
                    </template>
                    <!-- 专业投资者资格 -->
                    <template v-if="s.type==='professional'">
                      <div class="cfg-row"><span class="cfg-label">收集内容</span><div class="cfg-check-group"><el-checkbox v-model="s.professional.apply">是否申请专业投资者</el-checkbox><el-checkbox v-model="s.professional.waiver">权益放弃确认</el-checkbox><el-checkbox v-model="s.professional.assetProof">资产证明</el-checkbox><el-checkbox v-model="s.professional.expProof">投资经验证明</el-checkbox></div></div>
                    </template>
                    <!-- 触发条件（注册后补充时显示，各类型不同） -->
                    <template v-if="s.collectMode==='later' && (s.type==='address')">
                      <div class="cfg-row"><span class="cfg-label">触发条件</span><div class="cfg-control" style="flex-direction:column;align-items:flex-start;gap:12px;"><el-checkbox v-model="s.triggers.deposit">首次入金前提交</el-checkbox><el-checkbox v-model="s.triggers.withdraw">首次出金前提交</el-checkbox></div></div>
                    </template>
                    <template v-if="s.collectMode==='later' && (s.type==='bank' || s.type==='professional')">
                      <div class="cfg-row"><span class="cfg-label">触发条件</span><div class="cfg-control"><el-checkbox v-model="s.triggers.deposit">首次入金前提交</el-checkbox></div></div>
                    </template>
                    <template v-if="s.collectMode==='later' && s.type==='compliance'">
                      <div class="cfg-row"><span class="cfg-label">触发条件</span><div class="cfg-control" style="flex-direction:column;align-items:flex-start;gap:12px;"><el-checkbox v-model="s.triggers.deposit">首次入金前提交</el-checkbox><el-checkbox v-model="s.triggers.withdraw">首次出金前提交</el-checkbox></div></div>
                    </template>
                    <template v-if="s.collectMode==='later' && s.type==='fund'">
                      <div class="cfg-row"><span class="cfg-label">触发条件</span><div class="cfg-control" style="flex-direction:column;align-items:flex-start;gap:8px;"><div><el-checkbox v-model="s.triggers.singleAmount">单笔入金超过</el-checkbox><el-input-number v-model="s.triggers.singleAmountVal" :min="0" size="small" style="width:120px;margin:0 6px;"></el-input-number><el-select v-model="s.triggers.singleCurrency" size="small" style="width:80px;"><el-option label="USD" value="USD"></el-option><el-option label="CNY" value="CNY"></el-option><el-option label="EUR" value="EUR"></el-option></el-select></div><div><el-checkbox v-model="s.triggers.totalAmount">累计入金超过</el-checkbox><el-input-number v-model="s.triggers.totalAmountVal" :min="0" size="small" style="width:120px;margin:0 6px;"></el-input-number><el-select v-model="s.triggers.totalCurrency" size="small" style="width:80px;"><el-option label="USD" value="USD"></el-option><el-option label="CNY" value="CNY"></el-option><el-option label="EUR" value="EUR"></el-option></el-select></div></div></div>
                    </template>
                    <!-- 投资者适当性问卷 -->
                    <template v-if="s.type==='questionnaire'">
                      <div class="cfg-row"><span class="cfg-label">问卷内容</span><div class="cfg-control"><el-button type="text" style="color:var(--brand-primary);" @click="goToSurveyConfig">管理问卷题目 →</el-button></div></div>
                    </template>
                    <template v-if="s.collectMode==='later' && s.type==='questionnaire'">
                      <div class="cfg-row"><span class="cfg-label">触发条件</span><div class="cfg-control" style="flex-direction:column;align-items:flex-start;gap:8px;"><el-checkbox v-model="s.triggers.deposit">首次入金前提交</el-checkbox><div><el-checkbox v-model="s.triggers.totalAmount">累计入金超过</el-checkbox><el-input-number v-model="s.triggers.totalAmountVal" :min="0" size="small" style="width:120px;margin:0 6px;"></el-input-number><el-select v-model="s.triggers.totalCurrency" size="small" style="width:80px;"><el-option label="USD" value="USD"></el-option><el-option label="CNY" value="CNY"></el-option><el-option label="EUR" value="EUR"></el-option></el-select></div><el-checkbox v-model="s.triggers.highLeverage">申请高杠杆前必须完成</el-checkbox></div></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="config-footer">
              <el-button @click="resetRegConfig">重置</el-button>
              <el-button v-auth="'business:regConfig:save'" type="primary" @click="saveRegConfig">保存配置</el-button>
            </div>
          </div>
        </div>
    <!-- ============ 审核模式切换确认对话框 ============ -->
    <el-dialog title="切换为人工审核" :visible.sync="manualConfirmVisible" width="420px" :close-on-click-modal="false">
      <div style="font-size:13px;line-height:1.8;">
        <p>切换为<strong>人工审核</strong>后：</p>
        <ul style="padding-left:20px;color:#666;">
          <li>所有用户注册将需要人工审核通过</li>
          <li>建议同步更新国家名单设置</li>
          <li>切换后即时生效</li>
        </ul>
        <p style="margin-top:8px;">确定要切换到人工审核模式吗？</p>
      </div>
      <div slot="footer">
        <el-button @click="manualConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSwitchManual">确定切换</el-button>
      </div>
    </el-dialog>

    <el-dialog title="切换为自动审核" :visible.sync="autoConfirmVisible" width="420px" :close-on-click-modal="false">
      <div style="font-size:13px;line-height:1.8;">
        <p>切换为<strong>自动审核</strong>后：</p>
        <ul style="padding-left:20px;color:#666;">
          <li>系统将自动通过符合条件的注册申请</li>
          <li>高风险用户仍会触发人工审核</li>
          <li>切换后即时生效</li>
        </ul>
        <p style="margin-top:8px;">确定要切换到自动审核模式吗？</p>
      </div>
      <div slot="footer">
        <el-button @click="autoConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSwitchAuto">确定切换</el-button>
      </div>
    </el-dialog>

    <!-- ============ 国家编辑弹窗 ============ -->
    <el-dialog :title="countryDialogTitle" :visible.sync="countryDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="countryForm" label-width="110px">
        <el-form-item label="国家代码"><el-input v-model="countryForm.countryCode" placeholder="如 CN"></el-input></el-form-item>
        <el-form-item label="国家名称"><el-input v-model="countryForm.countryName" placeholder="如 China"></el-input></el-form-item>
        <el-form-item label="中文名称"><el-input v-model="countryForm.countryCname" placeholder="如 中国"></el-input></el-form-item>
        <el-form-item label="名单状态">
          <el-select v-model="countryForm.status" placeholder="请选择" style="width:100%;">
            <el-option label="白名单" value="whitelist"></el-option>
            <el-option label="灰名单" value="graylist"></el-option>
            <el-option label="黑名单" value="blacklist"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风险等级">
          <el-select v-model="countryForm.riskLevel" placeholder="请选择" style="width:100%;">
            <el-option label="低" value="low"></el-option>
            <el-option label="中" value="medium"></el-option>
            <el-option label="高" value="high"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认分组ID"><el-input v-model="countryForm.defaultSegmentId" placeholder="如 SG001"></el-input></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="countryForm.sort" :min="0" style="width:100%;"></el-input-number></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="countryDialogVisible = false">取消</el-button>
        <el-button v-auth="'business:regConfig:edit'" type="primary" @click="saveCountry">保存</el-button>
      </div>
    </el-dialog>

    <!-- ============ 交易组别展示配置编辑弹窗 ============ -->
    <el-dialog :title="groupEditTitle" :visible.sync="groupEditVisible" width="560px" :close-on-click-modal="false">
      <el-form v-if="groupEditForm" :model="groupEditForm" label-width="110px">
        <div class="group-edit-section">基本信息</div>
        <el-form-item label="组别ID"><el-input v-model="groupEditForm.groupCode" disabled></el-input></el-form-item>
        <el-form-item label="默认币种"><el-input v-model="groupEditForm.currency" disabled></el-input></el-form-item>
        <!-- 组别杠杆 / 入金门槛：只读展示（分别来自 MT5 DemoLeverage 与 t_trade_group.min_threshold），
             渲染口径与上方表格同列一致；两者都不在本弹窗保存，改门槛请去「交易组别」菜单 -->
        <el-form-item label="组别杠杆">
          <el-input :value="groupEditForm.groupLeverage ? '1:' + groupEditForm.groupLeverage : '-'" disabled></el-input>
        </el-form-item>
        <el-form-item label="入金门槛">
          <el-input :value="Number(groupEditForm.minThreshold) > 0 ? formatAmount(groupEditForm.minThreshold) : '-'" disabled></el-input>
        </el-form-item>
        <el-form-item label="交易组别"><el-input v-model="groupEditForm.groupName" disabled></el-input></el-form-item>
        <el-form-item label="MT5交易组"><el-input v-model="groupEditForm.mt5GroupPath" disabled></el-input></el-form-item>

        <div class="group-edit-section">客户端配置</div>
        <el-form-item label="客户端展示名称"><el-input v-model="groupEditForm.displayName" maxlength="100" placeholder="展示给客户的名称"></el-input></el-form-item>
        <el-form-item label="说明文案"><el-input v-model="groupEditForm.displayContent" type="textarea" :rows="2" maxlength="255" placeholder="说明文案"></el-input></el-form-item>
        <el-form-item>
          <template slot="label">图片文件 </template>
          <div class="group-edit-file-box">
            <el-upload action="#" :show-file-list="false" accept="image/jpeg,image/png,image/gif"
              :before-upload="beforeGroupImageUpload" :http-request="doUploadGroupImage">
              <el-button size="small">选择文件</el-button>
            </el-upload>
            <img v-if="groupEditForm.displayImage" :src="groupEditForm.displayImage" class="group-edit-file-thumb" alt="">
            <span class="group-edit-file-state">{{ groupImageUploading ? '上传中...' : (groupEditForm.displayFileName || '未选择任何文件') }}</span>
            <span class="group-edit-file-hint">(jpg/png/gif, ≤2MB)</span>
          </div>
        </el-form-item>
        <el-form-item label="是否展示">
          <el-switch v-model="groupEditForm.shown" :active-value="1" :inactive-value="2" @change="onGroupEditShowChange"></el-switch>
        </el-form-item>
        <el-form-item label="客户端默认">
          <el-switch v-model="groupEditForm.isDefault" :active-value="1" :inactive-value="2" :disabled="groupEditForm.shown !== 1"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button :disabled="groupEditSaving" @click="groupEditVisible = false">取消</el-button>
        <el-button v-auth="'business:regConfig:save'" type="primary" :loading="groupEditSaving" @click="saveGroupEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  countryList, countryAddOrUpdate,
  getRegConfigByCountry, saveRegConfigAll, saveRegConfigTradeGroups,
  deleteCountryConfig, uploadTradeGroupImage
} from '@/api/regConfig'

/** 证件类型池元数据：UI bool key(camel) ↔ configJson token(snake)，sample 为该证件号码输入框占位示例 */
const DOC_TYPE_META = [
  { key: 'idCard', jsonKey: 'doc_number', label: '身份证', sample: '请输入身份证号' },
  { key: 'passport', jsonKey: 'passport', label: '护照', sample: '请输入护照号' },
  { key: 'driverLicense', jsonKey: 'driver_license', label: '驾驶证', sample: '请输入驾驶证号' },
  { key: 'residencePermit', jsonKey: 'residence_permit', label: '居留许可', sample: '请输入居留许可号' }
]

export default {
  name: 'RegConfigList',
  data() {
    return {
      regMethodTab: 'phone',
      // ==================== 交易组别配置 ====================
      requireSelectGroup: 1,
      tradeGroups: [],
      groupDefaultId: null,
      // 交易组别编辑弹窗
      groupEditVisible: false,
      groupEditTitle: '编辑交易组别',
      groupEditRow: null,
      groupEditForm: null,
      groupImageUploading: false,
      groupEditSaving: false,
      // ==================== 开户配置 ====================
      currentCountry: 'default',
      currentReviewMode: 1,
      regConfigLoading: false,
      // loadRegConfig 请求序号，用于丢弃乱序返回的旧国家配置（见 loadRegConfig）
      regConfigSeq: 0,
      allCountries: [],
      sidebarCountries: [],
      addingCountry: null,
      showCountrySelect: false,
      // 邮箱注册配置（enabled: 1=启用, 2=禁用）
      emailConfig: { id: null, methodType: 1, enabled: 1 },
      emailRequired: { email: true, password: false, confirmPassword: false, country: false },
      emailKyc: { realName: false, idDoc: false, birthDate: false, birthCountry: false, nationality: false, residenceCountry: false, taxResidence: false, tinNumber: false },
      emailDocTypes: { idCard: false, passport: false, driverLicense: false, residencePermit: false },
      // 证件号码占位文案不在管理页展示/编辑：仅静默保留已入库的 docNumberPrompts，保存时透传保证 getConfig 继续返回
      emailDocNumberPrompts: {},
      emailDocPhotos: { front: false, back: false, handheld: false },
      emailBiometric: { selfie: false, faceCompare: false },
      // 手机注册配置（enabled: 1=启用, 2=禁用）
      phoneConfig: { id: null, methodType: 2, enabled: 1 },
      phoneRequired: { phone: true, password: false, confirmPassword: false, country: false },
      phoneKyc: { realName: false, idDoc: false, birthDate: false, birthCountry: false, nationality: false, residenceCountry: false, taxResidence: false, tinNumber: false },
      phoneDocTypes: { idCard: false, passport: false, driverLicense: false, residencePermit: false },
      // 证件号码占位文案不在管理页展示/编辑：仅静默保留已入库的 docNumberPrompts，保存时透传保证 getConfig 继续返回
      phoneDocNumberPrompts: {},
      phoneDocPhotos: { front: false, back: false, handheld: false },
      phoneBiometric: { selfie: false, faceCompare: false },
      // 补充资料配置（邮箱）
      emailSupplementMaster: 1,
      emailSupplements: [
        { type:'address', icon:'📍', label:'地址信息证明', enabled:1, collectMode:'open', expanded:false, sort:0, validMonths:3,
          fields:{text:false,file:false}, addrTypes:{utility:false,bank:false,government:false},
          triggers:{deposit:false,withdraw:false} },
        { type:'bank', icon:'🏦', label:'银行资料', enabled:1, collectMode:'open', expanded:false, sort:1,
          bankFields:{verifyHolder:false,bankName:false,accountNo:false,swift:false,iban:false,sortCode:false},
          triggers:{deposit:false,withdraw:false} },
        { type:'fund', icon:'💰', label:'资金来源证明', enabled:1, collectMode:'open', expanded:false, sort:2,
          fundSources:{salary:false,investment:false,deposit:false,business:false,inheritance:false,property:false,loan:false,gift:false,other:false},
          fundDocs:{bankStatement:false,taxReceipt:false,assetProof:false,bizLicense:false},
          triggers:{deposit:false,withdraw:false,singleAmount:false,singleAmountVal:10000,singleCurrency:'USD',totalAmount:false,totalAmountVal:50000,totalCurrency:'USD'} },
        { type:'compliance', icon:'🛡️', label:'合规及监管筛查', enabled:1, collectMode:'open', expanded:false, sort:3,
          compliance:{financialCrime:0,regulatoryAction:0,sanctionsList:0,pep:0,fatca:0,
            fatcaRules:{birthCountry:false,nationalityUS:false,residenceUS:false,taxUS:false,phoneUS:false,addressUS:false},
            strictKyc:{selfRep:false,thirdPartyFund:false,pepRelation:false}},
          triggers:{deposit:false,withdraw:false} },
        { type:'professional', icon:'🎓', label:'专业投资者资格', enabled:1, collectMode:'open', expanded:false, sort:4,
          professional:{apply:false,waiver:false,assetProof:false,expProof:false},
          triggers:{deposit:false,withdraw:false} },
        { type:'questionnaire', icon:'📋', label:'投资者适当性问卷', enabled:1, collectMode:'open', expanded:false, sort:5,
          triggers:{deposit:false,withdraw:false,totalAmount:false,totalAmountVal:10000,totalCurrency:'USD',highLeverage:false} }
      ],
      // 补充资料配置（手机，初始从email深拷贝）
      phoneSupplementMaster: 1,
      phoneSupplements: [],
      manualConfirmVisible: false,
      autoConfirmVisible: false,
      pendingReviewMode: null,

      // ==================== 国家弹窗 ====================
      countryDialogVisible: false, countryDialogTitle: '编辑国家配置',
      countryForm: { id: null, countryCode: '', countryName: '', countryCname: '', status: 'whitelist', riskLevel: 'low', defaultSegmentId: '', sort: 0 },
      editingCountry: false
    }
  },
  mounted() {
    this.phoneSupplements = JSON.parse(JSON.stringify(this.emailSupplements))
    this.initPage()
  },
  computed: {
    currSupps() { return this.regMethodTab === 'email' ? this.emailSupplements : this.phoneSupplements },
    currSuppMaster: { get() { return this.regMethodTab === 'email' ? this.emailSupplementMaster : this.phoneSupplementMaster }, set(v) { if (this.regMethodTab === 'email') this.emailSupplementMaster = v; else this.phoneSupplementMaster = v } }
  },
  methods: {
    initPage() {
      this.fetchAllCountries()
      // 无参调用 getByCountry：仅取已配置国家列表填充左侧
      getRegConfigByCountry('').then(res => {
        if (res.code === 0 && res.result) {
          const d = res.result
          if (d.configuredCountries && d.configuredCountries.length > 0) {
            this.sidebarCountries = d.configuredCountries
              .map(code => this.allCountries.find(c => c.countryCode === code))
              .filter(Boolean)
          }
        }
      })
      // 左侧默认选中“默认配置”(DEFAULT)，加载其开户配置
      this.currentCountry = 'default'
      this.loadRegConfig('default')
    },

    // ==================== 国家列表 ====================
    fetchAllCountries() {
      countryList({ pageNum: 1, pageSize: 500 }).then(res => {
        if (res.code === 0) {
          this.allCountries = res.result.list || []
        }
      })
    },

    openCountrySelect() {
      this.showCountrySelect = true
      this.addingCountry = null
      this.$nextTick(() => {
        this.$refs.countrySelect && this.$refs.countrySelect.focus()
      })
    },

    onCountryClear() {
      this.showCountrySelect = false
      this.addingCountry = null
    },

    onCountrySelect(countryCode) {
      if (!countryCode) return
      const found = this.sidebarCountries.find(c => c.countryCode === countryCode)
      if (!found) {
        const full = this.allCountries.find(c => c.countryCode === countryCode)
        if (full) {
          this.sidebarCountries.push({ ...full })
        }
      }
      // 走与左侧点击完全同一条切换路径：选中态、清空面板、加载配置三者必须同步
      this.switchCountry(countryCode)
      this.showCountrySelect = false
      this.addingCountry = null
    },

    /** 清空右侧配置面板，恢复初始未选中状态 */
    clearRegPanel() {
      this.currentReviewMode = 1
      this.emailConfig = { id: null, methodType: 1, enabled: 1 }
      this.phoneConfig = { id: null, methodType: 2, enabled: 1 }
      // 必须用变量承接，不能直接以 [ 开头写这条语句：上一行 this.phoneConfig = {...} 结尾没有分号，
      // ASI 不会在这里补分号，整句会被解析成 ({...})[this.emailSupplements, this.phoneSupplements]
      // 的成员访问 —— 逗号表达式取到 phoneSupplements（空数组 → 键 ''）→ undefined.forEach 直接抛错，
      // 结果是 clearRegPanel 中断、调用方后面的 loadRegConfig 不执行（表现为「右侧还是上一个国家的配置」）。
      const supplementLists = [this.emailSupplements, this.phoneSupplements]
      supplementLists.forEach(arr => arr.forEach(s => {
        s.enabled = 1; s.collectMode = 'open'; s.expanded = false; s.id = null
        if (s.type==='address') { s.validMonths = 3; s.fields = {text:false,file:false}; s.addrTypes = {utility:false,bank:false,government:false} }
        if (s.type==='bank') { s.bankFields = {verifyHolder:false,bankName:false,accountNo:false,swift:false,iban:false,sortCode:false} }
        if (s.type==='fund') { s.fundSources = {salary:false,investment:false,deposit:false,business:false,inheritance:false,property:false,loan:false,gift:false,other:false}; s.fundDocs = {bankStatement:false,taxReceipt:false,assetProof:false,bizLicense:false}; s.triggers = {deposit:false,withdraw:false,singleAmount:false,singleAmountVal:10000,singleCurrency:'USD',totalAmount:false,totalAmountVal:50000,totalCurrency:'USD'} }
        if (s.type==='compliance') { s.compliance = {financialCrime:0,regulatoryAction:0,sanctionsList:0,pep:0,fatca:0,fatcaRules:{birthCountry:false,nationalityUS:false,residenceUS:false,taxUS:false,phoneUS:false,addressUS:false},strictKyc:{selfRep:false,thirdPartyFund:false,pepRelation:false}} }
        if (s.type==='professional') { s.professional = {apply:false,waiver:false,assetProof:false,expProof:false} }
        if (s.type==='questionnaire') { s.triggers = {deposit:false,withdraw:false,totalAmount:false,totalAmountVal:10000,totalCurrency:'USD',highLeverage:false} }
        if (!s.triggers) s.triggers = {deposit:false,withdraw:false}
      }))
      // 补充资料主开关（页面上「补充资料」卡片右上角的开关）也要复位：
      // applyConfigJson 只在 cfg.supplement 非空时才赋值，缺失时不会覆盖，
      // 不复位就会把上一个国家的主开关状态带到新国家（配置残留的典型来源）
      this.emailSupplementMaster = 1
      this.phoneSupplementMaster = 1
      // 重置所有字段checkbox为未选中
      this.resetFieldCheckboxes()
      // 重置交易组别展示配置
      this.requireSelectGroup = 1
      this.tradeGroups = []
      this.groupDefaultId = null
      this.groupEditVisible = false
      this.groupEditRow = null
      this.groupEditForm = null
    },

    /** 重置所有注册字段checkbox为未选中 */
    resetFieldCheckboxes() {
      const allFalse = { password: false, confirmPassword: false, country: false }
      const kycFalse = { realName: false, idDoc: false, birthDate: false, birthCountry: false, nationality: false, residenceCountry: false, taxResidence: false, tinNumber: false }
      const docTypesFalse = { idCard: false, passport: false, driverLicense: false, residencePermit: false }
      const docPhotosFalse = { front: false, back: false, handheld: false }
      const biometricFalse = { selfie: false, faceCompare: false }
      this.emailRequired = { ...allFalse, email: true }
      this.emailKyc = { ...kycFalse }
      this.emailDocTypes = { ...docTypesFalse }
      this.emailDocNumberPrompts = {}
      this.emailDocPhotos = { ...docPhotosFalse }
      this.emailBiometric = { ...biometricFalse }
      this.phoneRequired = { ...allFalse, phone: true }
      this.phoneKyc = { ...kycFalse }
      this.phoneDocTypes = { ...docTypesFalse }
      this.phoneDocNumberPrompts = {}
      this.phoneDocPhotos = { ...docPhotosFalse }
      this.phoneBiometric = { ...biometricFalse }
    },

    getFlagEmoji(code) {
      if (!code) return '📍'
      try {
        const pts = code.toUpperCase().split('').map(c => 127397 + c.charCodeAt())
        return String.fromCodePoint(...pts)
      } catch (e) { return '📍' }
    },

    /** 切换国家（左侧点击 / 添加国家配置选中，两条入口共用）：选中态 + 清空右侧面板 + 加载配置，
     *  三者必须同步 —— 原来这里漏了 clearRegPanel，而 applyConfigJson 是「响应里有 key 才覆盖」的
     *  部分合并（如 cfg.supplement 为 null 时整段补充资料不动），于是新国家会继承上一个国家的残留配置，
     *  表现为「右侧显示的还是上一个国家的配置，刷新页面才对」。 */
    switchCountry(code) {
      this.currentCountry = code
      this.clearRegPanel()
      this.loadRegConfig(code)
    },

    handleCountryMenu(cmd, country) {
      if (cmd !== 'remove') return
      // 删除：删除 t_reg_method_switch_config 中该国家的数据
      this.$confirm(`确定删除 ${country.countryCode} 的全部注册配置吗？`, '提示', { type: 'warning' }).then(() => {
        deleteCountryConfig(country.countryCode).then(res => {
          if (res.code === 0) {
            this.$message.success('已删除')
            const idx = this.sidebarCountries.findIndex(c => c.countryCode === country.countryCode)
            if (idx >= 0) this.sidebarCountries.splice(idx, 1)
            if (this.currentCountry === country.countryCode) {
              this.currentCountry = 'default'
              this.clearRegPanel()
            }
          }
        })
      }).catch(() => {})
    },

    saveCountry() {
      const data = { ...this.countryForm }
      if (this.editingCountry) data.id = this.countryForm.id
      countryAddOrUpdate(data).then(res => {
        if (res.code === 0) {
          this.$message.success(this.editingCountry ? '编辑成功' : '添加成功')
          this.countryDialogVisible = false
          this.fetchAllCountries()
        }
      })
    },

    setCurrSuppMaster(v) {
      if (this.regMethodTab === 'email') this.emailSupplementMaster = v; else this.phoneSupplementMaster = v
    },
    // ==================== 加载/保存配置（合并接口） ====================
    loadRegConfig(countryCode) {
      this.regConfigLoading = true
      const code = countryCode === 'default' ? 'DEFAULT' : countryCode
      // 请求序号防乱序：连续切换 A→B 时 A 的响应可能后到，若不设防会用 A 的配置覆盖 B 的面板，
      // 同样表现为「右侧是上一个国家的配置，刷新才好」。只认最后一次发起的请求。
      const seq = ++this.regConfigSeq
      getRegConfigByCountry(code).then(res => {
        if (seq !== this.regConfigSeq) return
        if (res.code === 0 && res.result) {
          this.applyRegConfigData(res.result)
        }
      }).finally(() => {
        // 已有更新的请求在飞时不要在这里收掉 loading，否则转圈会提前消失
        if (seq === this.regConfigSeq) this.regConfigLoading = false
      })
    },

    /** 将接口返回的配置数据应用到页面 */
    applyRegConfigData(d) {
      const applyMethodCfg = (method, target) => {
        const cfg = d[method + 'Config']
        if (cfg) {
          target.enabled = cfg.enabled != null ? cfg.enabled : 1
          target.id = cfg.id
          this.currentReviewMode = cfg.reviewMode || 1
          this.applyConfigJson(method, cfg.configJson)
        } else {
          target.id = null; target.enabled = 1
        }
      }
      applyMethodCfg('email', this.emailConfig)
      applyMethodCfg('phone', this.phoneConfig)

      // 交易组别：注册是否需选择开关 + 真实交易组展示配置（display_status/display_default 转 boolean 便于 UI 操作）
      if (d.requireSelectGroup != null) this.requireSelectGroup = d.requireSelectGroup
      this.tradeGroups = (d.tradeGroups || []).map(g => ({
        id: g.id,
        groupCode: g.groupCode,
        currency: g.currency,
        // 首次入金门槛：只读展示（单位同本行 currency），来自 t_trade_group.min_threshold，不参与本页保存
        minThreshold: g.minThreshold,
        // 组别杠杆：只读展示，来自 MT5 DemoLeverage（1:N），不参与本页保存
        groupLeverage: g.groupLeverage,
        groupName: g.groupName,
        mt5GroupPath: g.mt5GroupPath,
        displayName: g.displayName || '',
        displayContent: g.displayContent || '',
        displayImage: g.displayImage || '',
        shown: (g.displayStatus == null ? 1 : g.displayStatus) === 1,
        defaultFlag: (g.displayDefault == null ? 2 : g.displayDefault) === 1
      }))
      this.groupDefaultId = null
      const persistedDefault = this.tradeGroups.find(g => g.shown && g.defaultFlag)
      if (persistedDefault) {
        this.groupDefaultId = persistedDefault.id
      } else {
        // 历史数据可能未设默认：自动取首个展示行作为客户端默认，保证保存时满足至少一个默认
        const firstShown = this.tradeGroups.find(g => g.shown)
        this.groupDefaultId = firstShown ? firstShown.id : null
      }

      this.autoSelectRegTab()
    },

    /** 解析 configJson 回显 checkbox 状态 */
    applyConfigJson(method, jsonStr) {
      if (!jsonStr) return
      try {
        const cfg = JSON.parse(jsonStr)
        const regCfg = cfg.regFields || cfg
        const isEmail = method === 'email'
        const required = isEmail ? this.emailRequired : this.phoneRequired
        const kyc = isEmail ? this.emailKyc : this.phoneKyc
        const docTypes = isEmail ? this.emailDocTypes : this.phoneDocTypes
        const docPhotos = isEmail ? this.emailDocPhotos : this.phoneDocPhotos
        const biometric = isEmail ? this.emailBiometric : this.phoneBiometric

        if (regCfg.required) {
          required.password = regCfg.required.passwd !== false
          required.confirmPassword = regCfg.required.confirm_password !== false
          required.country = regCfg.required.country !== false
        }
        if (regCfg.kyc) {
          if ('name' in regCfg.kyc) kyc.realName = regCfg.kyc.name === true
          // 兼容旧格式 idDoc 和新格式 doc_type
          if ('doc_type' in regCfg.kyc || 'idDoc' in regCfg.kyc) {
            kyc.idDoc = (regCfg.kyc.doc_type || regCfg.kyc.idDoc) === true
          }
          if ('birth_date' in regCfg.kyc) kyc.birthDate = regCfg.kyc.birth_date === true
          if ('birth_country' in regCfg.kyc) kyc.birthCountry = regCfg.kyc.birth_country === true
          if ('nationality' in regCfg.kyc) kyc.nationality = regCfg.kyc.nationality === true
          if ('residence_country' in regCfg.kyc) kyc.residenceCountry = regCfg.kyc.residence_country === true
          if ('tax_residence' in regCfg.kyc) kyc.taxResidence = regCfg.kyc.tax_residence === true
          if ('tin_number' in regCfg.kyc) kyc.tinNumber = regCfg.kyc.tin_number === true
        }
        if (regCfg.docTypes) {
          const dt = regCfg.docTypes
          // 兼容历史 id_card 配置：新版以 doc_number 为准，旧 key 兜底
          // 一律严格按 true 判定：缺失 key / 非布尔值（1、"true"）都算未勾选。
          // 之前对缺失 key 用 `!== false` 兜底成 true，等于把「没配过」当成「已勾选」，
          // 只要 docTypes 是个空对象或少了某几个 key，回显就会把身份证/护照显示为选中并原样存回 DB
          const idCardRaw = dt.hasOwnProperty('doc_number')
            ? dt.doc_number
            : (dt.hasOwnProperty('id_card') ? dt.id_card : undefined)
          docTypes.idCard = idCardRaw === true
          docTypes.passport = dt.passport === true
          docTypes.driverLicense = dt.driver_license === true
          docTypes.residencePermit = dt.residence_permit === true
        }
        if (regCfg.docNumberPrompts) {
          const src = regCfg.docNumberPrompts
          // 统一占位：doc_number 优先，其次兼容历史按类型配置，取首个非空提示；仅静默保留，供保存时透传
          let v = src.doc_number
          if (typeof v !== 'string') {
            const keys = Object.keys(src)
            for (let i = 0; i < keys.length; i++) {
              if (typeof src[keys[i]] === 'string' && src[keys[i]]) { v = src[keys[i]]; break }
            }
          }
          const promptVal = typeof v === 'string' ? v : ''
          const docPrompts = promptVal ? { doc_number: promptVal } : {}
          if (isEmail) this.emailDocNumberPrompts = docPrompts
          else this.phoneDocNumberPrompts = docPrompts
        }
        if (regCfg.docPhotos) {
          docPhotos.front = regCfg.docPhotos.front !== false
          docPhotos.back = regCfg.docPhotos.back === true
          docPhotos.handheld = regCfg.docPhotos.handheld === true
        }
        if (regCfg.biometric) {
          biometric.selfie = regCfg.biometric.biometric_selfie === true
          biometric.faceCompare = regCfg.biometric.face_compare === true
        }
        const supps = method === 'email' ? this.emailSupplements : this.phoneSupplements
        // supplement: null=显式关闭, undefined=key不存在(旧数据), object=有配置
        if (cfg.supplement != null) {
          if (method === 'email') this.emailSupplementMaster = 1; else this.phoneSupplementMaster = 1
          supps.forEach(s => {
            try {
            const sup = cfg.supplement
            const collKey = { address:'address_collect', bank:'bank_collect', fund:'fund_collect', compliance:'compliance_collect', professional:'professional_collect', questionnaire:'questionnaire_collect' }[s.type]
            // 子项开关回显：开启保存时会写入 *_collect key，缺失即视为已关闭，避免保存后仍显示开启
            s.enabled = sup[collKey] ? 1 : 2
            if (!sup[collKey]) s.collectMode = 'open'
            // 兼容兜底：异常/历史数据可能缺失嵌套对象，先补齐避免下方赋值/遍历中断
            if (s.type === 'address') { s.fields = s.fields || { text:false, file:false }; s.addrTypes = s.addrTypes || { utility:false, bank:false, government:false } }
            else if (s.type === 'bank') s.bankFields = s.bankFields || { verifyHolder:false, bankName:false, accountNo:false, swift:false, iban:false, sortCode:false }
            else if (s.type === 'fund') { s.fundSources = s.fundSources || {}; s.fundDocs = s.fundDocs || {} }
            else if (s.type === 'compliance') { if (!s.compliance) s.compliance = { financialCrime:0, regulatoryAction:0, sanctionsList:0, pep:0, fatca:0, fatcaRules:{ birthCountry:false, nationalityUS:false, residenceUS:false, taxUS:false, phoneUS:false, addressUS:false }, strictKyc:{ selfRep:false, thirdPartyFund:false, pepRelation:false } }; const c = s.compliance; c.fatcaRules = c.fatcaRules || {}; c.strictKyc = c.strictKyc || {} }
            else if (s.type === 'professional') s.professional = s.professional || { apply:false, waiver:false, assetProof:false, expProof:false }
            s.triggers = s.triggers || {}
            if (s.type === 'address') {
              if (sup.address_collect) s.collectMode = sup.address_collect
              s.fields.text = !!sup.address_text; s.fields.file = !!sup.address_file
              s.addrTypes.utility = !!sup.address_file_utility; s.addrTypes.bank = !!sup.address_file_bank; s.addrTypes.government = !!sup.address_file_government
              if (sup.address_valid_months) s.validMonths = sup.address_valid_months
              if (sup.address_trigger_deposit) s.triggers.deposit = true; if (sup.address_trigger_withdraw) s.triggers.withdraw = true
            } else if (s.type === 'bank') {
              if (sup.bank_collect) s.collectMode = sup.bank_collect
              s.bankFields.verifyHolder = !!sup.bank_holder; s.bankFields.bankName = !!sup.bank_name; s.bankFields.accountNo = !!sup.bank_account
              s.bankFields.swift = !!sup.bank_swift; s.bankFields.iban = !!sup.bank_iban; s.bankFields.sortCode = !!sup.bank_sort_code
              if (sup.bank_trigger_deposit) s.triggers.deposit = true
            } else if (s.type === 'fund') {
              if (sup.fund_collect) s.collectMode = sup.fund_collect
              const fs = (s.fundSources && typeof s.fundSources === 'object') ? s.fundSources : {}
              const FUND_KEYS = ['salary','investment','deposit','business','inheritance','property','loan','gift','other']
              for (let i = 0; i < FUND_KEYS.length; i++) { const k = FUND_KEYS[i]; if (sup['fund_' + k]) fs[k] = true }
              const fdoc = (s.fundDocs && typeof s.fundDocs === 'object') ? s.fundDocs : {}
              fdoc.bankStatement = !!sup.fund_doc_bank_statement; fdoc.taxReceipt = !!sup.fund_doc_tax_receipt
              fdoc.assetProof = !!sup.fund_doc_asset_proof; fdoc.bizLicense = !!sup.fund_doc_biz_license
              const ftg = (s.triggers && typeof s.triggers === 'object') ? s.triggers : {}
              if (sup.fund_trigger_single) ftg.singleAmount = true; if (sup.fund_trigger_total) ftg.totalAmount = true
            } else if (s.type === 'compliance') {
              if (sup.compliance_collect) s.collectMode = sup.compliance_collect
              const c = s.compliance; if (sup.compliance_financial_crime) c.financialCrime = 1; if (sup.compliance_regulatory) c.regulatoryAction = 1
              if (sup.compliance_sanctions) c.sanctionsList = 1; if (sup.compliance_pep) c.pep = 1
              if (sup.compliance_fatca) c.fatca = 1; const fr = c.fatcaRules
              fr.birthCountry = !!sup.compliance_fatca_birth; fr.nationalityUS = !!sup.compliance_fatca_nationality
              fr.residenceUS = !!sup.compliance_fatca_residence; fr.taxUS = !!sup.compliance_fatca_tax
              fr.phoneUS = !!sup.compliance_fatca_phone; fr.addressUS = !!sup.compliance_fatca_address
              c.strictKyc.selfRep = !!sup.compliance_strict_self; c.strictKyc.thirdPartyFund = !!sup.compliance_strict_third; c.strictKyc.pepRelation = !!sup.compliance_strict_pep
              if (sup.compliance_trigger_deposit) s.triggers.deposit = true; if (sup.compliance_trigger_withdraw) s.triggers.withdraw = true
            } else if (s.type === 'professional') {
              if (sup.professional_collect) s.collectMode = sup.professional_collect
              const p = s.professional; p.apply = !!sup.professional_apply; p.waiver = !!sup.professional_waiver
              p.assetProof = !!sup.professional_asset; p.expProof = !!sup.professional_exp
              if (sup.professional_trigger_deposit) s.triggers.deposit = true
            } else if (s.type === 'questionnaire') {
              if (sup.questionnaire_collect) s.collectMode = sup.questionnaire_collect
              if (sup.questionnaire_trigger_deposit) s.triggers.deposit = true
              if (sup.questionnaire_trigger_total) { s.triggers.totalAmount = true; s.triggers.totalAmountVal = sup.questionnaire_trigger_total_val || 10000; s.triggers.totalCurrency = sup.questionnaire_trigger_total_cur || 'USD' }
              if (sup.questionnaire_trigger_high_leverage) s.triggers.highLeverage = true
            }
            } catch (e2) {
              console.error('[regConfig] 补充子项回显失败:', method, s && s.type, e2)
            }
          })
        } else if ('supplement' in cfg) {
          // supplement 显式为 null，表示后台主动关闭
          if (method === 'email') this.emailSupplementMaster = 2; else this.phoneSupplementMaster = 2
        }
        // cfg 中没有 supplement key（旧数据）→ 不改变 master，保持默认开启
      } catch (e) {
        // 若此处仍报错说明回显仍有中断（原静默吞异常导致开关长期不回显）
        console.error('[regConfig] applyConfigJson 回显被中断:', method, e)
      }
    },

    autoSelectRegTab() {
      // 已停留在交易组别配置页时不自动跳回注册方式页
      if (this.regMethodTab === 'group') return
      const emailOn = this.emailConfig.enabled === 1
      const phoneOn = this.phoneConfig.enabled === 1
      if (!phoneOn && emailOn) {
        this.regMethodTab = 'email'
      } else {
        this.regMethodTab = 'phone'
      }
    },

    saveRegConfig() {
      const countryCode = this.currentCountry === 'default' ? 'DEFAULT' : this.currentCountry
      const buildMethodCfg = (method) => {
        const isEmail = method === 'email'
        return {
          id: isEmail ? this.emailConfig.id : this.phoneConfig.id,
          enabled: isEmail ? this.emailConfig.enabled : this.phoneConfig.enabled,
          reviewMode: this.currentReviewMode,
          methodType: isEmail ? 1 : 2,
          configJson: JSON.stringify(this.buildConfigJson(method)),
          // 补充资料字段合并到 configJson 的 supplement 组中（不再单独传 supplementConfigs）

        }
      }
      // 展示中的交易组须存在客户端默认（隐藏行已自动取消默认）
      const shownGroups = this.tradeGroups.filter(g => g.shown)
      if (shownGroups.length > 0 && !shownGroups.some(g => g.id === this.groupDefaultId)) {
        this.$message.warning('请至少为一个展示的交易组别设置客户端默认')
        return
      }
      const data = {
        countryCode,
        emailConfig: buildMethodCfg('email'),
        phoneConfig: buildMethodCfg('phone'),
        requireSelectGroup: this.requireSelectGroup,
        tradeGroups: this.tradeGroups.map(g => ({
          id: g.id,
          displayName: (g.displayName || '').trim(),
          displayContent: (g.displayContent || '').trim(),
          displayImage: (g.displayImage || '').trim(),
          displayStatus: g.shown ? 1 : 2,
          displayDefault: (g.shown && g.id === this.groupDefaultId) ? 1 : 2
        }))
      }
      saveRegConfigAll(data).then(res => {
        if (res.code === 0) {
          this.$message.success('配置保存成功')
          this.loadRegConfig(this.currentCountry)
        } else {
          this.$message.warning('保存失败')
        }
      }).catch(() => { this.$message.error('保存失败') })
    },

    /** 构建单个注册方式的 configJson */
    buildConfigJson(method) {
      const isEmail = method === 'email'
      const config = isEmail ? this.emailConfig : this.phoneConfig
      const required = isEmail ? this.emailRequired : this.phoneRequired
      const kyc = isEmail ? this.emailKyc : this.phoneKyc
      const uiDocTypes = isEmail ? this.emailDocTypes : this.phoneDocTypes
      const docPhotos = isEmail ? this.emailDocPhotos : this.phoneDocPhotos
      const biometric = isEmail ? this.emailBiometric : this.phoneBiometric
      // 证件类型池开关：由元数据统一生成 JSON token（身份证→doc_number），保证与后端过滤的 option key 一致
      // ①「证件类型 + 证件号码」是总开关：关掉时证件类型池那行在页面上是隐藏的（v-show），
      //    里面残留的勾选值不能再写回 DB —— 否则会出现「页面上没选、库里却是 true」，
      //    而且后端只要 docTypes 里有一个 true 就会把 doc_type 字段带给 C 端
      // ② 值统一归一成布尔，避免历史非布尔值（1、"true"）存回后 Element 复选框显示未选中却是真值
      const docTypePoolOn = kyc.idDoc === true
      const docTypesJson = {}
      DOC_TYPE_META.forEach(m => { docTypesJson[m.jsonKey] = docTypePoolOn && uiDocTypes[m.key] === true })
      // 证件号码占位文案不在此编辑：透传已入库的 docNumberPrompts.doc_number（C端证件号码输入框占位），避免保存时被清空
      const prompts = (isEmail ? this.emailDocNumberPrompts : this.phoneDocNumberPrompts) || {}
      const docNumberPrompts = {}
      const promptVal = typeof prompts.doc_number === 'string' ? prompts.doc_number.trim() : ''
      if (promptVal) docNumberPrompts.doc_number = promptVal
      const configJson = JSON.stringify({
        regFields: {
          required: { passwd: required.password, confirm_password: required.confirmPassword, country: required.country },
          kyc: { name: kyc.realName, doc_type: kyc.idDoc, birth_date: kyc.birthDate, birth_country: kyc.birthCountry, nationality: kyc.nationality, residence_country: kyc.residenceCountry, tax_residence: kyc.taxResidence, tin_number: kyc.tinNumber },
          docTypes: docTypesJson,
          docNumberPrompts: docNumberPrompts,
          docPhotos: { front: docPhotos.front, back: docPhotos.back, handheld: docPhotos.handheld },
          biometric: { biometric_selfie: biometric.selfie, face_compare: biometric.faceCompare }
        },
        supplement: this.buildSupplementJson(method)
      })

      return {
        id: config.id,
        enabled: config.enabled,
        configJson: configJson,
        sort: 0
      }
    },

    resetRegConfig() {
      this.$confirm('确定要重置当前配置吗？', '提示', { type: 'warning' }).then(() => {
        this.loadRegConfig(this.currentCountry)
        this.$message.success('已重置')
      }).catch(() => {})
    },

    // ==================== 审核模式 ====================
    switchReviewMode(mode) {
      if (mode === this.currentReviewMode) return
      this.pendingReviewMode = mode
      if (mode === 2) { this.manualConfirmVisible = true } else { this.autoConfirmVisible = true }
    },
    confirmSwitchManual() { this.currentReviewMode = 2; this.manualConfirmVisible = false },
    confirmSwitchAuto() { this.currentReviewMode = 1; this.autoConfirmVisible = false },

    buildSupplementJson(method) {
      const isEmail = method === 'email'
      const supps = isEmail ? this.emailSupplements : this.phoneSupplements
      const master = isEmail ? this.emailSupplementMaster : this.phoneSupplementMaster
      if (master !== 1) return null
      const supp = {}
      supps.filter(s => s.enabled === 1).forEach(s => {
        const tr = s.collectMode === 'later' ? (s.triggers || {}) : {}
        if (s.type === 'address') {
          supp.address_collect = s.collectMode; if (s.fields.text) supp.address_text = true; if (s.fields.file) supp.address_file = true
          if (s.addrTypes.utility) supp.address_file_utility = true; if (s.addrTypes.bank) supp.address_file_bank = true
          if (s.addrTypes.government) supp.address_file_government = true; supp.address_valid_months = s.validMonths
          if (tr.deposit) supp.address_trigger_deposit = true; if (tr.withdraw) supp.address_trigger_withdraw = true
        } else if (s.type === 'bank') {
          supp.bank_collect = s.collectMode; const bf = s.bankFields || {}
          if (bf.verifyHolder) supp.bank_holder = true; if (bf.bankName) supp.bank_name = true
          if (bf.accountNo) supp.bank_account = true; if (bf.swift) supp.bank_swift = true
          if (bf.iban) supp.bank_iban = true; if (bf.sortCode) supp.bank_sort_code = true; if (tr.deposit) supp.bank_trigger_deposit = true
        } else if (s.type === 'fund') {
          supp.fund_collect = s.collectMode; const fs = s.fundSources || {}; const fd = s.fundDocs || {}
          // 同 clearRegPanel 的坑：上一行以 {} 结尾没分号、本行以 [ 开头，会被解析成
          // (s.fundDocs || {})['salary',...,'other'].forEach(...) —— 逗号表达式取到最后一项 → 取到 undefined 抛错。
          // 目前只因 data() 里 fundDocs 恒存在而侥幸没爆；一旦 fundDocs 缺失（正是 || {} 想兜的情况）就会抛，
          // 而这是保存链路，抛在这里等于整个补充资料存不进去。用变量承接，彻底断掉 ASI 依赖。
          const fundSourceKeys = ['salary','investment','deposit','business','inheritance','property','loan','gift','other']
          fundSourceKeys.forEach(k => { if (fs[k]) supp['fund_'+k] = true })
          if (fd.bankStatement) supp.fund_doc_bank_statement = true; if (fd.taxReceipt) supp.fund_doc_tax_receipt = true
          if (fd.assetProof) supp.fund_doc_asset_proof = true; if (fd.bizLicense) supp.fund_doc_biz_license = true
          if (tr.singleAmount) supp.fund_trigger_single = true; if (tr.totalAmount) supp.fund_trigger_total = true
        } else if (s.type === 'compliance') {
          supp.compliance_collect = s.collectMode; const c = s.compliance || {}
          if (c.financialCrime) supp.compliance_financial_crime = true; if (c.regulatoryAction) supp.compliance_regulatory = true
          if (c.sanctionsList) supp.compliance_sanctions = true; if (c.pep) supp.compliance_pep = true
          if (c.fatca) { supp.compliance_fatca = true; const fr = c.fatcaRules || {}
            if (fr.birthCountry) supp.compliance_fatca_birth = true; if (fr.nationalityUS) supp.compliance_fatca_nationality = true
            if (fr.residenceUS) supp.compliance_fatca_residence = true; if (fr.taxUS) supp.compliance_fatca_tax = true
            if (fr.phoneUS) supp.compliance_fatca_phone = true; if (fr.addressUS) supp.compliance_fatca_address = true }
          const sk = c.strictKyc || {}; if (sk.selfRep) supp.compliance_strict_self = true; if (sk.thirdPartyFund) supp.compliance_strict_third = true
          if (sk.pepRelation) supp.compliance_strict_pep = true; if (tr.deposit) supp.compliance_trigger_deposit = true; if (tr.withdraw) supp.compliance_trigger_withdraw = true
        } else if (s.type === 'professional') {
          supp.professional_collect = s.collectMode; const p = s.professional || {}
          if (p.apply) supp.professional_apply = true; if (p.waiver) supp.professional_waiver = true
          if (p.assetProof) supp.professional_asset = true; if (p.expProof) supp.professional_exp = true; if (tr.deposit) supp.professional_trigger_deposit = true
        } else if (s.type === 'questionnaire') { supp.questionnaire_collect = s.collectMode; if (tr.deposit) supp.questionnaire_trigger_deposit = true; if (tr.totalAmount) { supp.questionnaire_trigger_total = true; supp.questionnaire_trigger_total_val = tr.totalAmountVal; supp.questionnaire_trigger_total_cur = tr.totalCurrency; } if (tr.highLeverage) supp.questionnaire_trigger_high_leverage = true }
      })
      return supp
    },
    // ==================== 注册方式交互 ====================
    onEmailIdDocChange(val) {},
    onPhoneIdDocChange(val) {},
    /** 交易组「是否展示」变化：展示则保证有默认；隐藏原默认组则自动落到下一个展示组 */
    onGroupShowChange(row) {
      if (row.shown) {
        if (!this.groupDefaultId || !this.tradeGroups.some(g => g.shown && g.id === this.groupDefaultId)) {
          this.groupDefaultId = row.id
        }
      } else if (row.id === this.groupDefaultId) {
        const next = this.tradeGroups.find(g => g.shown && g.id !== row.id)
        this.groupDefaultId = next ? next.id : null
      }
    },
    onAddrProofFile(s) { if (!s.fields.file) s.addrTypes = { utility: false, bank: false, government: false } },
    goToSurveyConfig() { this.$router.push({ path: '/business/questionConfig/list', query: { label: this.$route.query.label } }) },

    /** 金额展示：千分位 + 固定两位小数（与「交易组别」页入金门槛列的格式一致） */
    formatAmount(value) {
      const num = Number(value)
      if (!Number.isFinite(num)) {
        return '-'
      }
      return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    // ==================== 交易组别展示配置编辑 ====================
    /** 打开编辑弹窗：表单稿与表格行双向同步，关闭弹窗即写回（取消时回滚） */
    openGroupEdit(row) {
      this.groupEditRow = row
      this.groupEditForm = {
        groupCode: row.groupCode,
        currency: row.currency,
        // 只读展示项（不参与保存）：组别杠杆来自 MT5 DemoLeverage，入金门槛来自 t_trade_group.min_threshold
        groupLeverage: row.groupLeverage,
        minThreshold: row.minThreshold,
        groupName: row.groupName,
        mt5GroupPath: row.mt5GroupPath,
        displayName: row.displayName,
        displayContent: row.displayContent,
        displayImage: row.displayImage || '',
        displayFileName: row.displayImage ? String(row.displayImage).split('/').pop() : '',
        shown: row.shown ? 1 : 2,
        isDefault: row.id === this.groupDefaultId ? 1 : 2
      }
      this.groupEditTitle = '编辑交易组别 - ' + (row.groupName || '')
      this.groupEditVisible = true
    },
    /** 客户端默认开关联动的展示开关：取消展示即不可默认 */
    onGroupEditShowChange(val) {
      if (val !== 1) this.groupEditForm.isDefault = 2
    },
    beforeGroupImageUpload(file) {
      const ok = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1
      if (!ok) { this.$message.warning('仅支持 jpg/png/gif 格式图片'); return false }
      if (file.size > 2 * 1024 * 1024) { this.$message.warning('图片大小不能超过 2MB'); return false }
      return true
    },
    doUploadGroupImage(opt) {
      this.groupImageUploading = true
      uploadTradeGroupImage(opt.file).then(res => {
        if (res.code === 0 && res.result) {
          this.groupEditForm.displayImage = res.result
          this.groupEditForm.displayFileName = opt.file.name
        } else {
          this.$message.warning('图片上传失败')
        }
      }).catch(() => { this.$message.error('图片上传失败') })
        .finally(() => { this.groupImageUploading = false })
    },
    /** 保存：写回表格行后调用后端接口持久化（仅保存交易组别展示配置） */
    saveGroupEdit() {
      const f = this.groupEditForm
      const row = this.groupEditRow
      if (!f || !row) { this.groupEditVisible = false; return }
      if (this.groupImageUploading) { this.$message.warning('图片上传中，请稍候'); return }
      row.displayName = f.displayName
      row.displayContent = f.displayContent
      row.displayImage = f.displayImage
      row.shown = f.shown === 1
      if (row.shown) {
        this.onGroupShowChange(row)
        if (f.isDefault === 1) this.groupDefaultId = row.id
      } else if (row.id === this.groupDefaultId) {
        this.onGroupShowChange(row)
      }
      // 展示中的交易组须存在客户端默认（隐藏行已自动取消默认）
      const shownGroups = this.tradeGroups.filter(g => g.shown)
      if (shownGroups.length > 0 && !shownGroups.some(g => g.id === this.groupDefaultId)) {
        this.$message.warning('请至少为一个展示的交易组别设置客户端默认')
        return
      }
      const countryCode = this.currentCountry === 'default' ? 'DEFAULT' : this.currentCountry
      this.groupEditSaving = true
      saveRegConfigTradeGroups({
        countryCode,
        tradeGroups: this.tradeGroups.map(g => ({
          id: g.id,
          displayName: (g.displayName || '').trim(),
          displayContent: (g.displayContent || '').trim(),
          displayImage: (g.displayImage || '').trim(),
          displayStatus: g.shown ? 1 : 2,
          displayDefault: (g.shown && g.id === this.groupDefaultId) ? 1 : 2
        }))
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('交易组别保存成功')
          this.groupEditVisible = false
          this.loadRegConfig(this.currentCountry)
        } else {
          this.$message.warning(res.message || '保存失败')
        }
      }).catch(() => { this.$message.error('保存失败') })
        .finally(() => { this.groupEditSaving = false })
    },

  }
}
</script>

<style scoped>
.reg-config-page { padding: 16px; background: #f5f7fa; min-height: 100%; }
/* 左国家栏 + 右内容 的两栏骨架：flex 子项默认 min-width:auto，会被内容（此处是交易组别那张宽表）
   的固有宽度顶开 → 整页横向溢出、右侧被裁掉。容器与右栏都必须显式 min-width:0，
   与「交易组别」页的 .trade-group-layout / .group-content 保持同一套写法 */
.reg-config-layout { display: flex; gap: 16px; min-height: 600px; min-width: 0; flex-wrap: nowrap; align-items: stretch; }
.reg-sidebar { flex: 0 0 220px; width: 220px; min-width: 220px; max-width: 100%; background: #fff; border-radius: 4px; padding: 12px; }
.sidebar-add-area { margin-bottom: 10px; }
.select-with-close { display: flex; align-items: center; gap: 4px; }
.close-select-btn { font-size: 16px; color: #909399; cursor: pointer; padding: 4px; border-radius: 2px; transition: color 0.2s; }
.close-select-btn:hover { color: #f56c6c; }
.country-list { margin-top: 4px; }
.country-item { display: flex; align-items: center; gap: 6px; padding: 8px 10px; border-radius: 4px; cursor: pointer; font-size: 13px; color: #333; margin-bottom: 2px; transition: background 0.15s; }
.country-item:hover { background: #f0f2f5; }
.country-item.active { background: var(--brand-primary-light); color: var(--brand-primary); font-weight: 500; }
.country-icon { font-size: 14px; width: 20px; text-align: center; flex-shrink: 0; }
.country-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.country-delete { font-size: 14px; color: #c0c4cc; padding: 0 4px; transition: color 0.2s; }
.country-delete:hover { color: #f56c6c; }
/* width:0 + flex-grow:1 ⇒ 宽度完全由 flex 分配决定，不再参考内容固有宽度；
   overflow:hidden ⇒ 放不下的表格由 el-table 自己出横向滚动条，而不是把整个页面撑宽 */
.reg-content { flex: 1 1 auto; width: 0; min-width: 0; max-width: 100%; overflow: hidden; background: #fff; border-radius: 4px; padding: 20px; min-height: 500px; }
.section-title { font-size: 13px; font-weight: 600; color: #303133; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #ebeef5; }
/* 两张审核模式卡：定死一个最小宽度当换行阈值，窄屏自动竖排 */
.review-mode-cards { display: flex; gap: 16px; flex-wrap: wrap; }
.review-mode-card { flex: 1 1 240px; min-width: 0; border: 2px solid #e4e7ed; border-radius: 8px; padding: 16px; cursor: pointer; display: flex; align-items: center; gap: 12px; transition: all 0.2s; position: relative; }
.review-mode-card:hover { border-color: var(--brand-primary-border); }
.review-mode-card.active { border-color: var(--brand-primary); background: var(--brand-primary-light); }
.card-icon { font-size: 28px; }
.card-info { flex: 1; }
.card-name { font-weight: 600; font-size: 13px; margin-bottom: 4px; }
.card-desc { font-size: 12px; color: #909399; }
.cfg-card { border: 1px solid #e4e7ed; border-radius: 6px; overflow: hidden; }
.cfg-card-header { display: flex; align-items: center; gap: 8px; padding: 10px 16px; background: #fafafa; font-size: 13px; font-weight: 500; border-bottom: 1px solid #e4e7ed; }
.cfg-card-body { padding: 16px; }
.cfg-section { margin-bottom: 8px; }
.cfg-section-title { font-size: 12px; font-weight: 600; color: #606266; margin-bottom: 10px; padding-left: 8px; border-left: 3px solid var(--brand-primary); }
.cfg-row { display: flex; align-items: flex-start; padding: 8px 0; border-bottom: 1px dashed #f0f0f0; }
.cfg-row:last-child { border-bottom: none; }
.cfg-label { width: 120px; min-width: 120px; font-size: 12px; color: #606266; padding-top: 4px; }
.cfg-control { flex: 1; }
.cfg-check-group { display: flex; flex-wrap: wrap; gap: 8px 16px; }
.config-footer { margin-top: 20px; padding-top: 16px; border-top: 1px solid #ebeef5; display: flex; justify-content: flex-end; gap: 8px; }
.table-wrapper { background: #fff; border-radius: 4px; padding: 16px; }
.table-header { margin-bottom: 12px; }
.search-form { margin-bottom: 12px; background: #fafafa; padding: 12px; border-radius: 4px; }
.capability-banner { background: linear-gradient(135deg, var(--brand-primary-light) 0%, var(--brand-primary-a08) 100%); border: 1px solid var(--brand-primary-border); border-radius: 8px; padding: 16px 20px; margin-bottom: 20px; }
.capability-title { font-size: 14px; font-weight: 600; color: #303133; margin-bottom: 6px; }
.capability-subtitle { font-size: 12px; color: #909399; margin: 0 0 12px 0; line-height: 1.5; }
/* minmax(0,1fr) 而非 1fr：避免栅格子项被 min-content 顶开（窄屏降列见文件末尾的媒体查询） */
.capability-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.capability-item { background: #fff; border: 1px solid #e4e7ed; border-radius: 6px; padding: 12px; text-align: center; }
.capability-icon { font-size: 20px; display: block; margin-bottom: 4px; }
.capability-name { font-size: 12px; font-weight: 600; color: #303133; display: block; margin-bottom: 2px; }
.capability-desc { font-size: 11px; color: #909399; line-height: 1.4; display: block; }
.supplement-sub-item { border-bottom: 1px solid #ebeef5; }
.supplement-sub-item:last-child { border-bottom: none; }
.supplement-sub-header { display: flex; align-items: center; padding: 10px 16px; cursor: pointer; font-size: 12px; color: #303133; transition: background 0.15s; }
.supplement-sub-header:hover { background: #f5f7fa; }
.supplement-sub-body { padding: 8px 16px 16px 48px; }
.group-body-disabled { opacity: 0.5; pointer-events: none; }
.group-img-thumb { width: 40px; height: 40px; object-fit: cover; border-radius: 4px; border: 1px solid #ebeef5; display: block; margin: 0 auto; }
.group-img-empty { font-size: 12px; color: #c0c4cc; }
.group-edit-section { font-size: 12px; font-weight: 600; color: #606266; margin: 4px 0 12px; padding-left: 8px; border-left: 3px solid var(--brand-primary); }
.group-edit-file-box { background: #f5f7fa; border: 1px solid #e6ebf0; border-radius: 6px; padding: 10px 14px; display: flex; align-items: center; gap: 12px; }
.group-edit-file-thumb { width: 64px; height: 64px; object-fit: cover; border-radius: 4px; border: 1px solid #e6ebf0; background: #fff; flex-shrink: 0; }
.group-edit-file-state { color: #999; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.group-edit-file-hint { margin-left: auto; color: #999; font-size: 12px; flex-shrink: 0; }
.group-empty { padding: 28px 0; text-align: center; font-size: 12px; color: #909399; }

/* ──────────────── 分辨率适配 ────────────────
   两栏骨架收紧 + 栅格降列；表格各列给的宽度都是下限，当前宽度放不下时
   由 el-table 自己出横向滚动条，不会再把整个页面撑宽。
   断点沿用仓库其它列表页（tradeGroup / tradeProduct / tradeHoliday）的口径。 */
@media (max-width: 1440px) {
  .reg-sidebar { flex-basis: 192px; width: 192px; min-width: 192px; }
  .reg-content { padding: 16px; }
}

@media (max-width: 1200px) {
  .reg-config-page { padding: 12px; }
  .reg-config-layout { gap: 12px; }
  .reg-sidebar { flex-basis: 172px; width: 172px; min-width: 172px; padding: 10px; }
  .capability-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .capability-banner { padding: 14px 16px; }
}

@media (max-width: 900px) {
  .capability-grid { grid-template-columns: minmax(0, 1fr); }
  .reg-sidebar { flex-basis: 150px; width: 150px; min-width: 150px; }
  /* 三个弹窗的宽度都是写死的 px（420/500/560），窄屏统一改成百分比。
     必须用 ::v-deep：本项目是 vue 2.6 + vue-loader 15，:deep(...) 不会被编译，
     原样输出成浏览器不认的选择器（规则静默失效） */
  .reg-config-page ::v-deep .el-dialog { width: 92% !important; }
}
</style>
